export interface SearchResponseParams {
  query: string;
  qin: string;
  fields: string;
  wt: string;
  sort?: string;
  rows?: string;
  start: number;
}
